module.exports = __webpack_public_path__ + "img/american-express.00b51627.svg";